// extracted by mini-css-extract-plugin
module.exports = {"cellCustom":"cell_cellCustom__Rw3Ai"};